import { ApiFetch } from "../Utils/ApiFetch";

export const defaultValueQuery = async (props, attToDefault, globalContext, isMassive, ids) => {
  let fieldValue = {};
  let fieldLabel = {};

  await Promise.all(attToDefault.map(field =>
    new Promise((resolve, reject) => {
      ApiFetch(
        `custom/form/sources/defaultValueByQuery/${props.globalModel}/${props.objectType}/${field.name}/${props.parentId}/${isMassive}`,
        globalContext,
        true,
        async body => {
          try {
            const resJson = await body.json();

            if(resJson) {
              if (isMassive) {
                fieldValue[field.name] = resJson
              } else {
                fieldValue[field.name] = resJson.key

                if (resJson.label)
                  fieldLabel[field.name] = resJson.label;
              }
            }
            
            resolve();
          } catch (err) {
            reject(err);
          }
        },
        error => {
          console.error('error custom/form/sources', error);
          reject(error);
        },
        { 
          method: 'POST',
          body: JSON.stringify({
            id_assets: ids
          }),
        }
      );
    })
  ));

  const arrayFields = isMassive ? transformDataToMassive(fieldValue) : []; 

  return { fieldValue, fieldLabel, arrayFields };
};

const transformDataToMassive = (input) => {
  const output = [];

  for (const fieldName in input) {
    for (const item of input[fieldName]) {
      const id = item.object_id;
      const key = item.key;

      let existing = output.find(obj => obj.id === id);

      if (!existing) {
        existing = { id };
        output.push(existing);
      }

      existing[fieldName] = key;
    }
  }

  return output;
};